export default __webpack_public_path__ + "static/media/diamond.411fc91d.svg";